<template>
  <div class="wrapper">
    <div class="top-nav">
      <div>
        <nav-common :nav="nav"></nav-common>
      </div>
    </div>
    <div class="detail">
      <item-detail :detail="detail"></item-detail>
    </div>
  </div>
</template>
<style scoped>
.top-nav {
  width: 100%;
  display: flex;
}
.detail {
  margin-top: 30px;
  width: 100%;
  border-width: 20px 1px 1px 1px;
  border-style: solid;
  border-color:#E6ECF2;
  padding:40px 30px;
  box-sizing: border-box;
  border-radius: 10px;

}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import itemDetail from "@/components/views/common/itemDetail.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      nav: {
        firsttitle: "公告",
        firstrouteName: "announceList",
        secondtitle: "",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      },
      detail:{}
    };
  },
  methods: {
    getDetail() {
      userApi.getactivityDeatil({id:this.$route.query.id}).then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    navCommon,
    itemDetail
  },
  mounted() {
      if (this.$route.query.annoceFlag == "2") {
        this.nav.secondtitle = "重要公告";
      }  else {
        this.nav.secondtitle = "重要活动";
      }
    
  this.getDetail()
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Announce/detail.vue